module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-photo-2-9e66d0761106f2d61900c28164563477.jpg";